// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* section2.css */
/* div {
  border: 1px solid black;
} */

.section2_container__7a8R7 {
  display: flex;
  flex-direction: column;
  align-items: center; /* 세로 중앙 정렬 */
}
.section2_text-head__U8Df2 {
  width : 100%;
  text-align: center; /* 텍스트 중앙 정렬 */
  font-size: 50px;
  letter-spacing: 10px;
  padding-top: 7%;
  padding-bottom: 7%;
}

.section2_grid-container__LGOER {
  display: grid;
  grid-template-columns: 1fr;
  gap: 0px;
  width: 100%
}

.section2_grid-item__lg91a {
  display: flex;
  flex-direction: column; /* 세로로 배치 */
  justify-content: center; /* 수직 중앙 정렬 */
  align-items: center; /* 수평 중앙 정렬 */
  padding-top: 5%;
  text-align: center;
  color: white;
}

.section2_item-1__XYVdo { background-color: #ECF4FA; }
.section2_item-2__OwPZt { background-color: #F6FCFF; }
.section2_item-3__oicD3 { background-color: #ECF4FA; }
.section2_item-4__sE-RM { background-color: #F6FCFF; }
.section2_item-5__WHF7s { background-color: #ECF4FA; }
.section2_item-6__vDuir { background-color: #F6FCFF; }
.section2_item-7__37Sng { background-color: #ECF4FA; }
.section2_item-8__4XIOW { background-color: #F6FCFF; }

.section2_text-small__ZZAck {
  font-size: 22px;
  color: black;
}

.section2_text-mid__mbiJS {
  font-size: 32px;
  color: black;
  font-weight: 1000;
}

.section2_text-small__ZZAck span {
  display: block;
  height: 5px; /* 줄 간격 */
}

@media (max-width: 767px) {

  .section2_text-head__U8Df2 {
    text-align: center; /* 텍스트 중앙 정렬 */
    font-size: 26px;
    letter-spacing: 4px;
  }

  .section2_grid-container__LGOER {
    width:95%;
    grid-template-columns: 1fr;
  }

  .section2_grid-item__lg91a {
    padding-bottom: 15px;
  }

  .section2_text-small__ZZAck {
    font-size: 14px;
  }
  
  .section2_text-mid__mbiJS {
    font-size: 18px;
    font-weight: 800;
  }

  .section2_image__YLcK7 {
    transform: scale(1);
  }
}

@media (min-width: 768px) and (max-width: 1023px){

  .section2_grid-item__lg91a {
    height : 400px
  }

  .section2_grid-container__LGOER {
    grid-template-columns: 1fr 1fr;
  }

  .section2_image__YLcK7 {
    transform: scale(1.5);
  }

  .section2_text-small__ZZAck {
    font-size: 18px;
  }
  
  .section2_text-mid__mbiJS {
    font-size: 28px;
    font-weight: 1000;
  }


  
}

@media (min-width: 1024px) {
  
  .section2_container__7a8R7 {
    padding-left: 10%;
    padding-right: 10%;
  }

  .section2_grid-container__LGOER {
    grid-template-columns: 1fr 1fr 1fr 1fr;
  }

  .section2_grid-item__lg91a {
    height : 500px
  }

  .section2_text-small__ZZAck {
    font-size: 20px;
  }
  
  .section2_text-mid__mbiJS {
    font-size: 30px;
    font-weight: 1000;
  }

  .section2_image__YLcK7 {
    transform: scale(1.5);
  }
}
`, "",{"version":3,"sources":["webpack://./src/Sections/section2.module.css"],"names":[],"mappings":"AAAA,iBAAiB;AACjB;;GAEG;;AAEH;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB,EAAE,aAAa;AACpC;AACA;EACE,YAAY;EACZ,kBAAkB,EAAE,cAAc;EAClC,eAAe;EACf,oBAAoB;EACpB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,0BAA0B;EAC1B,QAAQ;EACR;AACF;;AAEA;EACE,aAAa;EACb,sBAAsB,EAAE,WAAW;EACnC,uBAAuB,EAAE,aAAa;EACtC,mBAAmB,EAAE,aAAa;EAClC,eAAe;EACf,kBAAkB;EAClB,YAAY;AACd;;AAEA,0BAAU,yBAAyB,EAAE;AACrC,0BAAU,yBAAyB,EAAE;AACrC,0BAAU,yBAAyB,EAAE;AACrC,0BAAU,yBAAyB,EAAE;AACrC,0BAAU,yBAAyB,EAAE;AACrC,0BAAU,yBAAyB,EAAE;AACrC,0BAAU,yBAAyB,EAAE;AACrC,0BAAU,yBAAyB,EAAE;;AAErC;EACE,eAAe;EACf,YAAY;AACd;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,WAAW,EAAE,SAAS;AACxB;;AAEA;;EAEE;IACE,kBAAkB,EAAE,cAAc;IAClC,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,SAAS;IACT,0BAA0B;EAC5B;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,mBAAmB;EACrB;AACF;;AAEA;;EAEE;IACE;EACF;;EAEA;IACE,8BAA8B;EAChC;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;;;;AAIF;;AAEA;;EAEE;IACE,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA;IACE,sCAAsC;EACxC;;EAEA;IACE;EACF;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,qBAAqB;EACvB;AACF","sourcesContent":["/* section2.css */\n/* div {\n  border: 1px solid black;\n} */\n\n.container {\n  display: flex;\n  flex-direction: column;\n  align-items: center; /* 세로 중앙 정렬 */\n}\n.text-head {\n  width : 100%;\n  text-align: center; /* 텍스트 중앙 정렬 */\n  font-size: 50px;\n  letter-spacing: 10px;\n  padding-top: 7%;\n  padding-bottom: 7%;\n}\n\n.grid-container {\n  display: grid;\n  grid-template-columns: 1fr;\n  gap: 0px;\n  width: 100%\n}\n\n.grid-item {\n  display: flex;\n  flex-direction: column; /* 세로로 배치 */\n  justify-content: center; /* 수직 중앙 정렬 */\n  align-items: center; /* 수평 중앙 정렬 */\n  padding-top: 5%;\n  text-align: center;\n  color: white;\n}\n\n.item-1 { background-color: #ECF4FA; }\n.item-2 { background-color: #F6FCFF; }\n.item-3 { background-color: #ECF4FA; }\n.item-4 { background-color: #F6FCFF; }\n.item-5 { background-color: #ECF4FA; }\n.item-6 { background-color: #F6FCFF; }\n.item-7 { background-color: #ECF4FA; }\n.item-8 { background-color: #F6FCFF; }\n\n.text-small {\n  font-size: 22px;\n  color: black;\n}\n\n.text-mid {\n  font-size: 32px;\n  color: black;\n  font-weight: 1000;\n}\n\n.text-small span {\n  display: block;\n  height: 5px; /* 줄 간격 */\n}\n\n@media (max-width: 767px) {\n\n  .text-head {\n    text-align: center; /* 텍스트 중앙 정렬 */\n    font-size: 26px;\n    letter-spacing: 4px;\n  }\n\n  .grid-container {\n    width:95%;\n    grid-template-columns: 1fr;\n  }\n\n  .grid-item {\n    padding-bottom: 15px;\n  }\n\n  .text-small {\n    font-size: 14px;\n  }\n  \n  .text-mid {\n    font-size: 18px;\n    font-weight: 800;\n  }\n\n  .image {\n    transform: scale(1);\n  }\n}\n\n@media (min-width: 768px) and (max-width: 1023px){\n\n  .grid-item {\n    height : 400px\n  }\n\n  .grid-container {\n    grid-template-columns: 1fr 1fr;\n  }\n\n  .image {\n    transform: scale(1.5);\n  }\n\n  .text-small {\n    font-size: 18px;\n  }\n  \n  .text-mid {\n    font-size: 28px;\n    font-weight: 1000;\n  }\n\n\n  \n}\n\n@media (min-width: 1024px) {\n  \n  .container {\n    padding-left: 10%;\n    padding-right: 10%;\n  }\n\n  .grid-container {\n    grid-template-columns: 1fr 1fr 1fr 1fr;\n  }\n\n  .grid-item {\n    height : 500px\n  }\n\n  .text-small {\n    font-size: 20px;\n  }\n  \n  .text-mid {\n    font-size: 30px;\n    font-weight: 1000;\n  }\n\n  .image {\n    transform: scale(1.5);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `section2_container__7a8R7`,
	"text-head": `section2_text-head__U8Df2`,
	"grid-container": `section2_grid-container__LGOER`,
	"grid-item": `section2_grid-item__lg91a`,
	"item-1": `section2_item-1__XYVdo`,
	"item-2": `section2_item-2__OwPZt`,
	"item-3": `section2_item-3__oicD3`,
	"item-4": `section2_item-4__sE-RM`,
	"item-5": `section2_item-5__WHF7s`,
	"item-6": `section2_item-6__vDuir`,
	"item-7": `section2_item-7__37Sng`,
	"item-8": `section2_item-8__4XIOW`,
	"text-small": `section2_text-small__ZZAck`,
	"text-mid": `section2_text-mid__mbiJS`,
	"image": `section2_image__YLcK7`
};
export default ___CSS_LOADER_EXPORT___;
